import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { Group } from "../../utils/logger";
import {
  REPORT_LOADING,
  SET_RESULT_TYPES,
  SET_RESULT_SUBTYPES,
  SET_RESULT_COUNTS,
  SET_RESULT_STATS,
  RESET_REPORTS,
  ADD_REPORT_ERROR,
} from "../constants";

const Logger = new Group("Results Actions", { disable: true });

export const RESULT_SESSION_TOKEN = "amrnResultOptions";

export const addError = (error, name) => (dispatch) => {
  dispatch({ type: ADD_REPORT_ERROR, payload: error, name });
};

// ============================================================================
// Get Options ================================================================
// ============================================================================

export const getTypeOptions = (options) => (dispatch) => {
  Logger.emit(`Getting report typeOptions`);

  dispatch({ type: REPORT_LOADING, payload: "types" });

  return axios
    .post(`reports/results/types`, options)
    .then((res) => {
      const payload = get(res, "data.types");

      payload && dispatch({ type: SET_RESULT_TYPES, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting types", { error });
      toastr.error("Error", "There was a problem getting 'type' options. Please try again later");
      dispatch(addError(error, "types"));
    });
};

export const getSubTypeOptions = (options) => (dispatch) => {
  Logger.emit(`Getting report subTypeOptions`);

  dispatch({ type: REPORT_LOADING, payload: "subTypes" });

  return axios
    .post(`reports/results/sub-types`, options)
    .then((res) => {
      const payload = get(res, "data.sub_types");

      payload && dispatch({ type: SET_RESULT_SUBTYPES, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting sub-types", { error });
      toastr.error(
        "Error",
        "There was a problem getting 'sub-type' options. Please try again later"
      );
      dispatch(addError(error, "subTypes"));
    });
};

// ============================================================================
// Get Data ===================================================================
// ============================================================================

export const getResultCounts = (options) => (dispatch) => {
  Logger.emit(`Getting report counts with options`, options);

  dispatch({ type: REPORT_LOADING, payload: "counts" });

  return axios
    .post(`reports/results/counts`, options)
    .then((res) => {
      const payload = get(res, "data");

      payload && dispatch({ type: SET_RESULT_COUNTS, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error });
      dispatch(addError(error, "counts"));
    });
};

export const getCountsByResult = (options) => (dispatch) => {
  Logger.emit(`Getting report stats with options`, options);

  dispatch({ type: REPORT_LOADING, payload: "stats" });

  return axios
    .post(`reports/results/stats`, options)
    .then((res) => {
      const payload = get(res, "data.stats");

      dispatch({ type: SET_RESULT_STATS, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error: error });
      dispatch(addError(error, "stats"));
    });
};

//reset landing reducer state
export const resetState = () => ({ type: RESET_REPORTS });
